import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  QUERIES,
  WithChildren,
  buildQueryString,
  createResponseContext,
  initialQueryResponse,
} from '_metronic/helpers'
import { SncrBloco } from '../../core/_models'
import { getSncrBlocos } from '../../core/_requests'
import { useQueryRequest } from './QueryRequestProvider'

const QueryResponseContext = createResponseContext<SncrBloco>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { state } = useQueryRequest()
  const empresaId = state.params?.empresaId

  const query = useMemo(() => {
    const parametros = buildQueryString({ page: state.page, size: state.size })
    // Sort montado à mão: o separador do Spring é a vírgula literal.
    const sort = state.sort
      ? `sort=${state.sort},${state.order ?? 'desc'}`
      : 'sort=dataRetirada,desc'
    return [parametros, sort].filter(Boolean).join('&')
  }, [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.SNCR_BLOCOS_LIST, empresaId, query],
    () => getSncrBlocos(empresaId as number, query),
    {
      enabled: !!empresaId,
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
